<template>
    <div class="history_cont">
        <div class="history_box">
            <div class="chart_box">
                <div class="chart_title">
                    <div class="chart_text">
                        Historical Data Trend
                    </div>
                    <div class="chart_iconlist">
                        <div class="icon_box" v-for="(item, index) in iconlist" :key="index"
                            @click="choseitem(item, index)" :class="iconchose == index ? 'iconchose' : ''">
                            <img :src="iconchose == index ? item.url2 : item.url" alt="">
                        </div>
                    </div>
                </div>
                <div class="chart_content" v-if="bigchartdata">
                    <div class="bigchart" style="width: 100%;height: 100%; display: inline-block">
                        <maincharts :codMain="'iobigChart' + bigchartdata.title" :ChartData="bigchartdata"
                            class="maincharts" v-if="choseid == 0">
                        </maincharts>
                        <barcharts :codMain="'iobigChart' + bigchartdata.title" :ChartData="bigchartdata"
                            class="maincharts" v-if="choseid == 1">
                        </barcharts>
                        <linecharts :codMain="'iobigChart' + bigchartdata.title" :ChartData="bigchartdata"
                            class="maincharts" v-if="choseid == 2">
                        </linecharts>
                        <el-table :data="tableData" ref='tableRef' border style="width: 100%" v-if="choseid == 3"
                            height="300">
                            <el-table-column prop="title" label="Statistical Indicators" width="180">
                            </el-table-column>
                            <el-table-column :prop="item.name" :label="item.name" width="180"
                                v-for="(item, index) in tabletitle" :key="index">
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <div class="chart_list">
                <div class="list_box">
                    <div v-for="(i, index) in chartData" class="list_title" :key="index" @click="changeChart(i, index)"
                        :style="clickindex == index ? ' color:#008080;' : ''">
                        <div class="list_text">
                            {{ i.title }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import maincharts from "./charts/maincharts";
import barcharts from "./charts/barcharts";
import linecharts from "./charts/linecharts";
import commonApi from "@/api/common.js";
// import config from '@/utils/config';;

export default {
    components: {
        maincharts, barcharts, linecharts
    },
    data() {
        return {
            show: true,
            allControlData: null,
            openIndex: null,
            choseid: 0,
            iconchose: 0,
            iconlist: [
                {
                    id: 0,
                    url: require("../../../assets/11 (3).png"),
                    url2: require("../../../assets/11 (10).png"),
                },
                {
                    id: 1,
                    url: require("../../../assets/chart (1).png"),
                    url2: require("../../../assets/chart (3).png"),
                },
                {
                    id: 2,
                    url: require("../../../assets/1 (1).png"),
                    url2: require("../../../assets/1 (8).png"),
                },
                {
                    id: 3,
                    url: require("../../../assets/table (1).png"),
                    url2: require("../../../assets/table (3).png"),
                },
            ],
            chartData: null,
            bigchartdata: null,
            activeName: null,
            timer: null,
            clickindex: 0,
            tableData: [],
            tabletitle: []
        };
    },
    mounted() {
        this.openIndex = this.$route.query.index;
        this.getChartData(this.choseid);
        this.timer = window.setInterval(() => {
            setTimeout(this.getChartData(this.choseid), 0);
        }, 300000)
    },
    methods: {
        choseitem(item, index) {
            console.log(item, index);
            this.choseid = item.id
            this.bigchartdata = null

            this.iconchose = index
            // console.log(this.clickindex);

            this.getChartData(this.choseid)
        },
        getChartData(type) {
            this.$store.commit("changeloading", 1);
            console.log("v2 detail loading start------------")
            this.$http.get("/modules/chart", {
                params: {
                    index: this.openIndex,
                    chart_type: type
                },
            }).then(res => {
                if (res && res.data && res.data.data) {
                    console.log(res.data, 'response data-------------')
                    console.log("v2 detail loading end------------")
                    this.$store.commit("changeloading", 0);
                    this.chartData = res.data.data.result;
                    this.activeName = this.chartData.title
                    // this.changeChart(this.chartData[this.clickindex], this.clickindex)
                    this.tabletitle = []
                    this.tableData = []
                    if (this.choseid == 3) {
                        for (let b = 0; b < this.chartData[this.clickindex].legend.length; b++) {
                            this.tabletitle.push(this.chartData[this.clickindex].legend[b])
                        }
                        for (let a = 0; a < this.chartData[this.clickindex].xAxis.length; a++) {
                            let obj = {}
                            obj['title'] = this.chartData[this.clickindex].xAxis[a]
                            for (let c = 0; c < this.tabletitle.length; c++) {
                                let name = this.tabletitle[c].name
                                obj[name] = this.tabletitle[c].yAxis[a]
                            }
                            this.tableData.push(obj)
                        }
                    }
                    // console.log(this.tabletitle);
                    // console.log(this.tableData);
                    this.bigchartdata = this.chartData[this.clickindex];
                } else {
                    console.log(res, 'response data-------------')
                    this.$store.commit("changeloading", 0);
                }
            })
        },
        changeChart(item, index) {
            console.log(item, index);
            this.tabletitle = []
            this.tableData = []
            this.clickindex = index

            // if (index) {
            // }
            console.log(item);
            if (this.choseid == 3) {
                for (let b = 0; b < item.legend.length; b++) {
                    this.tabletitle.push(item.legend[b])
                }
                for (let a = 0; a < item.xAxis.length; a++) {
                    let obj = {}
                    obj['title'] = item.xAxis[a]
                    for (let c = 0; c < this.tabletitle.length; c++) {
                        let name = this.tabletitle[c].name
                        obj[name] = this.tabletitle[c].yAxis[a]
                    }
                    this.tableData.push(obj)
                }
            }
            console.log(this.tabletitle);
            console.log(this.tableData);
            this.bigchartdata = item;
            console.log(item);
            this.$nextTick(() => {
                this.$refs.tableRef.doLayout()
            })
        },
        onmouserin() {

        }
    },
};
</script>

<style lang="scss" scoped>
.history_cont {
    .history_box {
        // margin-top: 46px;
        padding-top: 18px;
        // padding-left: 34px;
        display: flex;
        width: 1689px;
        height: 439px;
        opacity: 1;
        border-radius: 26px;
        background: #212121FF;
        box-shadow: 0px 2.6px 9.1px rgba(0, 0, 0, 0.05);

        .chart_box {
            margin-left: 34px;

            .chart_title {
                display: flex;
                justify-content: space-between;

                .chart_text {
                    left: 808.3px;
                    top: 314.6px;
                    width: 282px;
                    height: 28px;
                    opacity: 1;
                    /** 文本1 */
                    font-size: 18px;
                    font-weight: 600;
                    letter-spacing: 0px;
                    line-height: 27.42px;
                    color: #C5C5C5;

                    text-align: left;
                    vertical-align: top;
                }

                .chart_iconlist {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 196.3px;
                    height: 39px;
                    border-radius: 22.1px;
                    background: rgba(0, 128, 128, 1);

                    .iconchose_box {
                        left: 1892.5px;
                        top: 314.6px;
                        width: 52px;
                        height: 29.9px;
                        opacity: 1;
                        border-radius: 22.1px;
                        background: rgba(255, 255, 255, 1);
                    }

                    .icon_box {
                        margin-right: 10px;
                        margin-left: 10px;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        img {
                            width: 22.1px;
                            height: 19.5px;
                            opacity: 1;
                        }
                    }

                    .iconchose {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        text-align: center;
                        width: 52px;
                        height: 29.9px;
                        opacity: 1;
                        border-radius: 22.1px;
                        background: rgba(255, 255, 255, 1);
                        background-color: #fff;
                    }
                }
            }

            .chart_content {
                width: 1285px;
                height: 380px;

                .maincharts {
                    width: 100%;
                    height: 100%;
                    margin: 0 auto;
                    margin-bottom: 20px;
                    margin-left: 30px;
                }

                // background-color: red;
            }
        }

        .chart_list {
            margin-left: 36px;
            left: 2110.9px;
            top: 306.8px;
            width: 312px;
            height: 421.2px;
            opacity: 1;
            border-radius: 19.5px;
            overflow-y: scroll;
            // background: rgba(250, 251, 255, 1);
            box-shadow: 0px 2.6px 9.1px rgba(0, 0, 0, 0.05);

            .list_box {
                margin-top: 22px;
            }

            .list_title {
                cursor: pointer;
                // width: 100%;
                margin-left: 24px;
                margin-right: 24px;
                // text-align: center;
                // background-color: red;
                border-bottom: 1.3px solid rgba(204, 204, 204, 1);
                display: flex;
                color: #C5C5C5;
                // vertical-align: middle;
                align-items: center;
                // justify-content: center;

                .list_text {
                    margin-top: 10px;
                    margin-bottom: 10px;
                    font-size: 18.2px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 26.35px;
                    // color: rgba(23, 130, 212, 1);
                    text-align: left;
                    vertical-align: top;
                }
            }

            .clicktitle {
                color: #008080;
            }
        }
    }

}


::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}


::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #ddd;
    border-radius: 3px;
}
</style>
